import React, { useState, useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Auth } from 'aws-amplify';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const IdleTimeout = ({ isAuthenticated, onLogout }) => {
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(30); // 30 seconds countdown
  const countdownIntervalRef = useRef(null);

  const handleIdle = () => {
    if (isAuthenticated) {
      setOpen(true);
      setCountdown(30);
    }
  };

  const { reset } = useIdleTimer({
    timeout: 1000 * 60 * 10, // 10 minutes idle time
    promptTimeout: 1000 * 30, // 30 seconds prompt time
    onIdle: handleIdle,
    debounce: 500,
    disabled: !isAuthenticated,
  });

  const handleStayLoggedIn = async () => {
    try {
      // Refresh Cognito session
      await Auth.currentSession();
      setOpen(false);
      reset();
      clearInterval(countdownIntervalRef.current);
    } catch (error) {
      console.error('Error refreshing session:', error);
      onLogout();
    }
  };

  const handleLogout = () => {
    setOpen(false);
    clearInterval(countdownIntervalRef.current);
    onLogout();
  };

  useEffect(() => {
    if (open && isAuthenticated) {
      countdownIntervalRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownIntervalRef.current);
            handleLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(countdownIntervalRef.current);
    };
  }, [open, isAuthenticated]);

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Session Timeout Warning</DialogTitle>
      <DialogContent>
        <Typography>
          You have been inactive for a while. Your session will expire in{' '}
          {countdown} seconds.
        </Typography>
        <Typography>Would you like to stay logged in?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogout} color="secondary">
          Logout
        </Button>
        <Button onClick={handleStayLoggedIn} color="primary" variant="contained">
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleTimeout;